var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.59 7.90997L6 3.32997L1.41 7.90997L0 6.49997L6 0.499973L12 6.49997L10.59 7.90997Z","fill":"#2F2357"}));
}

ChevronUp.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
